/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { RevokePushTokenDTO } from '../models';
// @ts-ignore
import type { RevokeiOSPushToken200Response } from '../models';
/**
 * PushApi - axios parameter creator
 */
export const PushApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary revokeAndroidPushToken
         * @param {RevokePushTokenDTO} revokePushTokenDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAndroidPushToken: async (revokePushTokenDTO: RevokePushTokenDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revokePushTokenDTO' is not null or undefined
            assertParamExists('revokeAndroidPushToken', 'revokePushTokenDTO', revokePushTokenDTO)
            const localVarPath = `/api/nora/event/push/android/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokePushTokenDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary revokeiOSPushToken
         * @param {RevokePushTokenDTO} revokePushTokenDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeiOSPushToken: async (revokePushTokenDTO: RevokePushTokenDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revokePushTokenDTO' is not null or undefined
            assertParamExists('revokeiOSPushToken', 'revokePushTokenDTO', revokePushTokenDTO)
            const localVarPath = `/api/nora/event/push/ios/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokePushTokenDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PushApi - functional programming interface
 */
export const PushApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PushApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary revokeAndroidPushToken
         * @param {RevokePushTokenDTO} revokePushTokenDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAndroidPushToken(revokePushTokenDTO: RevokePushTokenDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevokeiOSPushToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAndroidPushToken(revokePushTokenDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PushApi.revokeAndroidPushToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary revokeiOSPushToken
         * @param {RevokePushTokenDTO} revokePushTokenDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeiOSPushToken(revokePushTokenDTO: RevokePushTokenDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevokeiOSPushToken200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeiOSPushToken(revokePushTokenDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PushApi.revokeiOSPushToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PushApi - factory interface
 */
export const PushApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PushApiFp(configuration)
    return {
        /**
         * 
         * @summary revokeAndroidPushToken
         * @param {PushApiRevokeAndroidPushTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAndroidPushToken(requestParameters: PushApiRevokeAndroidPushTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<RevokeiOSPushToken200Response> {
            return localVarFp.revokeAndroidPushToken(requestParameters.revokePushTokenDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary revokeiOSPushToken
         * @param {PushApiRevokeiOSPushTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeiOSPushToken(requestParameters: PushApiRevokeiOSPushTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<RevokeiOSPushToken200Response> {
            return localVarFp.revokeiOSPushToken(requestParameters.revokePushTokenDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for revokeAndroidPushToken operation in PushApi.
 */
export interface PushApiRevokeAndroidPushTokenRequest {
    readonly revokePushTokenDTO: RevokePushTokenDTO
}

/**
 * Request parameters for revokeiOSPushToken operation in PushApi.
 */
export interface PushApiRevokeiOSPushTokenRequest {
    readonly revokePushTokenDTO: RevokePushTokenDTO
}

/**
 * PushApi - object-oriented interface
 */
export class PushApi extends BaseAPI {
    /**
     * 
     * @summary revokeAndroidPushToken
     * @param {PushApiRevokeAndroidPushTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeAndroidPushToken(requestParameters: PushApiRevokeAndroidPushTokenRequest, options?: RawAxiosRequestConfig) {
        return PushApiFp(this.configuration).revokeAndroidPushToken(requestParameters.revokePushTokenDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary revokeiOSPushToken
     * @param {PushApiRevokeiOSPushTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeiOSPushToken(requestParameters: PushApiRevokeiOSPushTokenRequest, options?: RawAxiosRequestConfig) {
        return PushApiFp(this.configuration).revokeiOSPushToken(requestParameters.revokePushTokenDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

